import React from 'react'

// MUI Imports
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import { Button, Card, Divider, Grid, Hidden, Typography } from '@mui/material'
import BrightnessPercent from 'mdi-material-ui/BrightnessPercent'
import CirleSmall from 'mdi-material-ui/CircleSmall'
import { useTheme } from '@emotion/react'
import LayoutContainer from 'src/components/common/containers/LayoutContainer'
import { useCheckoutUI } from 'src/lib/contexts/CheckoutUIContext'
import DiscountBadge from 'public/images/coupon.svg'
import Image from 'next/image'

interface CouponCardPreviewProps {
  id: string | undefined
  identifier: string | undefined
  descTitle?: string
  desc?: string
  longDesc?: string[]
  hideApply?: boolean
  hideLongDesc?: boolean
}

const CouponCardPreview: React.FC<CouponCardPreviewProps> = ({
  id,
  identifier,
  descTitle,
  desc,
  longDesc,
  hideApply = false,
  hideLongDesc = false
}) => {
  const theme: any = useTheme()
  const {
    getters: { checkoutUI }
  } = useCheckoutUI()

  const themeColor = checkoutUI?.colorPalette?.primaryColor?.substring(0, 7)
  const backgroundImage = `linear-gradient(180deg, ${themeColor}1A, transparent)`

  return (
    <div
      style={{
        borderRadius: 18,
        height: 'fit-content',
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #F0F0F0',
        background: '#FFFFFF',
        width: '400px'
      }}
    >
      <div
        style={{
          display: 'flex',
          borderRadius: 16,
          padding: '1rem .75rem',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundImage: backgroundImage
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start',
            gap: 10,
            width: '360px',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          <img
            src={`/images/coupon.svg`}
            className='h-6 w-6 fill-primary-dark stroke-primary-dark text-primary-dark'
            alt='coupon-img'
          />
          <Typography
            variant='subtitle1'
            sx={{ fontWeight: 600, textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', whiteSpace: 'nowrap' }}
          >
            {identifier}
          </Typography>
        </div>
      </div>
      {Boolean(descTitle?.length || desc?.length) ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            gap: 2,
            padding: '0rem  .75rem'
          }}
        >
          <Typography
            variant='body1'
            sx={{ fontWeight: 600, width: '380px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
          >
            {descTitle}
          </Typography>
          <Typography variant='body2' sx={{ color: '#6E6E6E', lineHeight: '1rem', width: '380px' }}>
            {desc}
          </Typography>
        </div>
      ) : (
        <></>
      )}
      {!hideLongDesc ? (
        <List
          sx={{
            backgroundColor: '#FAFAFA',
            borderRadius: 2,
            padding: '0.5rem',
            border: '1px solid #F5F5F5',
            margin: '1rem .75rem'
          }}
        >
          {longDesc?.map((point: string, index: number) => (
            <ListItem
              sx={{
                display: 'flex',
                gap: 0,
                padding: 0,
                alignItems: 'start'
              }}
              key={`${point}_${index}`}
            >
              <CirleSmall />
              <Typography
                variant='body2'
                sx={{ fontWeight: 400, lineHeight: '1rem', letterSpacing: '0.02rem', marginTop: 1 }}
              >
                {point}
              </Typography>
            </ListItem>
          ))}
        </List>
      ) : (
        <></>
      )}
    </div>
  )
}

export default CouponCardPreview
